module.exports = {
	message: {
        // 俄罗斯语
		home: {
			language: "Русский язык",
			keyword:'Ключевое слово',
			hotPro:'Горячие продажи продукции',
			product:'Основные продукты',
			about:'О нас',
			aboutDesc:'Обслуживание клиентов, удовлетворенность клиентов',
			news:'Последние новости',
			company:'Компания-производитель',
			proVideo:'Рекламное видео',
			certificate:'Свидетельство о допущении',
			factory:'Кооперативный завод (кооперативный завод)'
		},
		about:{
			advantages:'Наши преимущества',
			factory:'Выставка на заводе',
			honors:'Почетные звания и сертификаты',
			honorsDesc:'Мы преследуем его цель-служить вам лучше',
			title1:'Производственные мощности',
			content1:'Полностью принадлежит, огромный, современный завод',
			title2:'Конкурентоспособная цена',
			content2:'Разумная цена, высокая эффективность затрат',
			title3:'Быстрая доставка',
			content3:'Несколько складов, расположенных в главном грузовом порту',
			title4:'Сотрудники категории специалистов',
			content4:'Команда специалистов по разработке, производству, экспорту',
			free1:'Индивидуальные услуги',
			frcon1:'Под рециркуляцией металла понимается физическая или механическая переработка полезных материалов, отделенных от металлолома, в переработанные продукты. Это производственная цепочка от переработки, разборки до переработки. Промышленность по рециркуляции металлов сформировала целостную промышленную цепочку и экосистему рециркуляции. По мере постепенного внедрения странами с формирующейся рыночной экономикой технологий и образа жизни, аналогичных тем, которые используются в странах оэср, глобальный спрос на металлы в будущем будет в 3-9 раз превышать общемировой спрос на металлы. Рециркуляция сложных металлических продуктов может решить и справиться с проблемами, вызванными резким ростом спроса на металлы.',
			free2:'Контроль качества',
			frcon2:'Оборудование для рециркуляции металлов включает главным образом дробильное и пульвезирующее оборудование, сортировочное оборудование, оборудование для предварительной обработки, регенерационное оборудование и т.д. Различное оборудование играет ключевую роль в различных звеньях рециркуляции металлов. Это оборудование широко используется для переработки металлолома и повышения эффективности использования ресурсов, охватывая различные технические средства, такие как физическое дробление, магнитное разделение, уплотнение и т.д.',
			free3:'Комплексная логистика',
			frcon3:'Фабрика металлоперерабатывающего центра нашей компании специализируется на переработке всех видов металлических отходов и занимается рециркуляцией и переработкой редких металлов. Ассортимент рециклирования в магазинах охватывает весь мир, предоставляя удобные услуги, такие как анализ цен на месте и операции с наличностью. Наша компания специализируется на высокосодержательных (90%) металлических отходах, которые могут быть переработаны независимо от веса или формы.',
			free4:'Инспекция третьей стороной',
			frcon4:'Помимо воздействия на окружающую среду добычи и выплавки металлов, она также потребляет от 7% до 8% мирового энергоснабжения. Рециркуляция потребляет меньше энергии, чем первичное производство металлов, снижая при этом общее воздействие на добычные участки. Рециркуляция металлов может также снизить спрос на низкосортные руды, избегая добычи некоторых драгоценных металлов, которые будут дефицитными в будущем.',
			new1:'Новости',
			new2:'Новости компании',
			new3:'Новости отрасли'
		},
		service:{
			ourservice:'Наши услуги',
			questions:'Часто задаваемые вопросы',
			message:'Оставьте ваше сообщение',
			hours:'Пожалуйста, оставьте сообщение. Мы ответим вам в течение 24 часов.',
			name:'Ваше имя:',
			mail:'Адрес электронной почты :*',
			tel:'Тел/Whatsapp:',
			type:'Тип продукта :*',
			video:'Видео о нас',
			up:'На последней странице',
			next:'На следующей странице'
		},
		contact:{
			help:'Мы здесь, чтобы помочь',
			helpDesc:'Свяжитесь с нами через следующую контактную информацию',
			manager:'Менеджер по продажам',
			phone:'Телефон/Whatsapp/Wechat',
			sendeamil:'Отправить по электронной почте',
			ouraddress:'Наш адрес'
		}, 
		foot:{
			navigation:'Быстрая навигация',
			type:'По категориям',
			mobile:'Мобильный (WHATSAPP/WECHAT)',
			email:'Электронная почта',
			address:'адрес',
			number:'Номер заявки',
			service:'Один стоп-сервис, выбор проще'
		},
		product:{
			description:'Описание',
			technical:'Технические характеристики',
			advantages:'Преимущества и преимущества',
			related:'Связанные с ними товары',
			videoDesc:'Сталелитейные заводы китая с наивысшим качеством, самыми низкими ценами, высокими комиссиями, верными агентами.',
			ti1:'Пожалуйста, введите адрес электронной почты.',
			ti2:'Пожалуйста, введите тип.',
			ti3:'Пожалуйста, заполните форму.'
		},
		nav:{
			home:'Главная страница',
			about:'О нас',
			products:'Товары для дома',
			news:'новост',
			video:'виде',
			free:'Рециркуляция и бесплатные технологии',
			contact:'связ',
			vr:'Вп (VR)',
			chat:'В чате',
			whatsapp:'В чем дело',
			wechat:'wechat',
			message:'Сообщение для прессы',
			tel:'телефон',
			top:'Главная страница',
		},
		btn:{
			read:'Читать далее',
			news:'Другие новости',
			exhibition:'Больше информации',
			watchVideo:'Смотреть больше видео',
			services:'Услуги и услуги',
			products:'Товары для дома',
			contactus:'Свяжитесь с нами',
			inquiry:'Запрос сейчас',
			size:'размер',
			packing:'PackУпаковка (по запросу)ing',
			service:'Онлайн-сервис',
			submit:'представ',
			sendEmial:'Отправить по электронной почте',
			now:'Заказать сейчас',
			text1:'Не стесняйтесь обращаться к нам в любое время.',
			text2:'Мы разрабатываем содержание и гранулярность материалов, которые отвечают вашим потребностям.',
			text3:'Независимо от того, необходимо ли вам повысить безопасность, максимальную производственную мощность или надежность, или сократить затраты, мы поставляем.',
			text4:'Мы стремимся обеспечить исключительное обслуживание клиентов и предоставление высококачественной продукции нашим ценным клиентам.',
			text5:'Ориентируйтесь на высококачественное производство феррокремния и кремниевых металлов',
			text6:'* советы: 1. Какой товар вам нужен? 2. Что вы планируете делать? 3. Когда вам понадобится этот продукт?'
		}
    }
};
